/* Show an offer after visible browsing time and a first scroll, never over another task. */
if (!customElements.get('mq-combo-offer')) {
  customElements.define('mq-combo-offer', class MqComboOffer extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      clearTimeout(this.timer);
      this.controller = new AbortController();
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      const options = { signal: this.controller.signal };
      this.key = `mq-combos-popup-${this.dataset.section}`;
      this.elapsed = 0;
      this.started = document.hidden ? null : performance.now();
      this.scrolled = window.scrollY >= 180;
      this.shown = false;

      this.querySelector('.mq-combo-popup__close')?.addEventListener('click', () => this.dialog.close(), options);
      this.querySelector('.mq-combo-popup__later')?.addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right ||
            event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);

      if (this.dataset.designMode === 'true') {
        document.addEventListener('shopify:section:select', event => {
          if (event.detail.sectionId === this.dataset.section && !this.dialog.open) this.dialog.showModal();
        }, options);
        return;
      }
      try { if (sessionStorage.getItem(this.key) === '1') return; } catch { /* Storage may be restricted. */ }

      window.addEventListener('scroll', () => {
        if (window.scrollY >= 180) this.scrolled = true;
        this.schedule();
      }, { ...options, passive: true });
      document.addEventListener('visibilitychange', () => {
        if (this.started !== null) this.elapsed += performance.now() - this.started;
        this.started = document.hidden ? null : performance.now();
        this.schedule();
      }, options);
      this.schedule();
    }

    schedule() {
      clearTimeout(this.timer);
      if (this.shown || document.hidden || !this.isConnected) return;
      const duration = this.elapsed + (this.started === null ? 0 : performance.now() - this.started);
      const remaining = Math.max(0, (Number(this.dataset.delay) || 20000) - duration);
      this.timer = setTimeout(() => this.maybeShow(), remaining || 1000);
    }

    maybeShow() {
      if (this.shown || document.hidden || !this.isConnected) return;
      const editing = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
      const occupied = document.querySelector('dialog[open], cart-drawer.active, .drawer.active, menu-drawer details[open]');
      if (!this.scrolled || editing || occupied) {
        this.timer = setTimeout(() => this.maybeShow(), 1000);
        return;
      }
      this.dialog.showModal();
      this.shown = true;
      try { sessionStorage.setItem(this.key, '1'); } catch { /* The current instance still remembers. */ }
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.dialog?.close();
    }
  });
}
